import React, { useState, useEffect } from "react";
import image2 from './assets/wishlist.jpg';
import image1 from './assets/zarashirt.jpg';
import image3 from './assets/addtoCollection.png';
import image4 from './assets/swiping.png';

export default function App() {
    const images = [
        image1,
        image4,
        image3,
        image2,
    ];
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % images.length);
        }, 4000);
        return () => clearInterval(interval);
    }, [images.length]);

    return (
        <div className="min-h-screen bg-white text-gray-900 flex flex-col items-center font-sans">
            {/* Header */}
            <header className="w-full py-6 px-8 flex justify-between items-center max-w-6xl">
                <h1 className="text-2xl font-semibold tracking-tight">Vidtie</h1>
                <button className="text-sm border border-gray-300 rounded-full px-4 py-1.5 hover:bg-gray-100 transition">
                    Coming Soon
                </button>
            </header>

            {/* Hero Section */}
            <main className="flex flex-col items-center text-center px-6 mt-12">
                <h2 className="text-4xl sm:text-6xl font-light mb-4 leading-tight">
                    Discover fashion from your favorite brands
                </h2>
                <p className="text-lg text-gray-600 max-w-xl mb-10">
                    Vidtie is a swipe-to-shop fashion discovery platform that lets you browse clothing and accessories from top brands with a simple swipe. 
                    Explore trending looks, and instantly save or shop the items you love — all in one sleek, mobile-friendly app powered by AI.
                </p>

                {/* Image Carousel - Portrait Mode with proper fit */}
                <div className="relative w-full max-w-xs sm:max-w-sm md:max-w-md aspect-[9/16] mb-12 overflow-hidden rounded-3xl shadow-xl border border-gray-100">
                    {images.map((img, idx) => (
                        <img
                            key={idx}
                            src={img}
                            alt={`Vidtie app view ${idx + 1}`}
                            className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-700 ease-in-out rounded-3xl bg-white ${idx === currentIndex ? "opacity-100" : "opacity-0"
                                }`}
                        />
                    ))}
                </div>

                {/* Email Signup */}
                <form
                    onSubmit={(e) => e.preventDefault()}
                    className="flex flex-col sm:flex-row items-center gap-3 w-full max-w-md mb-20"
                >
                    <input
                        type="email"
                        placeholder="Enter your email"
                        className="w-full px-4 py-3 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-black"
                    />
                    <button
                        type="submit"
                        className="px-6 py-3 bg-black text-white rounded-full hover:bg-gray-800 transition"
                    >
                        Notify Me
                    </button>
                </form>
            </main>

            {/* Footer */}
            <footer className="w-full py-6 text-center text-gray-500 text-sm border-t border-gray-100">
                © {new Date().getFullYear()} Vidtie. All rights reserved.
            </footer>
        </div>
    );
}
